import { Modelo } from '@ext/index';
import * as Types from './Contenidos.types';
import moment ,{ Moment } from 'moment';

export class IContenido extends Modelo {

    public constructor( Json: any = null ) {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id : number = 0;
public Articulo : string = '';
public Tipo : string = '';
public Nombre : string = '';
public Archivo : string = '';


    public getJson(): any {
        let json: any = {};

        json.id = this.Id;
json.articulo = this.Articulo;
json.tipo = this.Tipo;
json.nombre = this.Nombre;
json.archivo = this.Archivo;


        return json;
    }


    public set(): boolean {

        this.Id = !this.Json.id ? 0 : this.Json.id;
this.Articulo = !this.Json.articulo ? '' : this.Json.articulo;
this.Tipo = !this.Json.tipo ? '' : this.Json.tipo;
this.Nombre = !this.Json.nombre ? '' : this.Json.nombre;
this.Archivo = !this.Json.archivo ? '' : this.Json.archivo;


        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista {
        return new Vista( this );
    }
}

class Vista {
    constructor( Model: IContenido ) {
        this.Model = Model;
    }

    public Model: IContenido;
}